import styled from 'styled-components'

export const Content = styled.section`
  background: ${({ theme }) => theme.color.background.neutral.weak};
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.km6};
  align-items: center;
  padding: ${({ theme }) => theme.padding.km6};
`

export const ContentText = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.km6};
  align-items: center;
`

export const ContentButton = styled.div`
  max-width: 330px;
  width: 100%;
`

export const InnerButton = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.km2};
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
`
